import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Contract } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const contractsUrl = `${environment.apiUrl}/contracts`;
const contractDetailUrl = contractId => `${environment.apiUrl}/contractdetail/${contractId}`;
const contractTypeUrl = contractType => `${environment.apiUrl}/contracts/type/${contractType}`;

@Injectable()
export class ContractService {
  constructor(private readonly httpService: HttpService) {}

  getContracts(): Observable<Contract[]> {
    return this.httpService.get<Contract[]>(contractsUrl);
  }

  createContract(contract: Contract): Observable<Contract> {
    return this.httpService.post(contractsUrl, contract);
  }

  updateContract(contract: Contract): Observable<Contract> {
    return this.httpService.put(contractDetailUrl(contract.id), contract).map(response => response.json() as Contract);
  }

  deleteContract(id: number): Observable<Contract> {
    return this.httpService.delete(contractDetailUrl(id)).map(response => response.json() as Contract);
  }

  getContract(id: number): Observable<Contract> {
    return this.httpService.get<Contract>(contractDetailUrl(id));
  }

  getContractsWithType(type: string): Observable<Contract[]> {
    return this.httpService.get<Contract[]>(contractTypeUrl(type));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contract.service.ts